module.exports = __webpack_public_path__ + "img/logo.d29320b0.png";